import { createRouter, createWebHistory } from "vue-router";
import { canSee, firstAllowedPath, pageOf } from "../utils/pagePerms";
const router = createRouter({
    history: createWebHistory(),
    routes: [
        // 租户端
        { path: "/login", component: () => import("../views/tenant/Login.vue") },
        {
            path: "/",
            component: () => import("../views/tenant/Layout.vue"),
            children: [
                { path: "", redirect: "/overview" },
                { path: "users", component: () => import("../views/tenant/Users.vue") },
                // 2026-09-21 系统设置(审批人 / 公司资料)· 只给管理员
                { path: "settings", component: () => import("../views/tenant/Settings.vue") },
                // 平台层 · 第六轮
                { path: "overview", component: () => import("../views/tenant/dashboard/Overview.vue") },
                { path: "chain-trace", component: () => import("../views/tenant/dashboard/ChainTrace.vue") },
                // 商品链路 · hub 里含 4 tab(本公司/主表/导入/分类)· 主表详情单独 route 保持深链
                { path: "product-hub", component: () => import("../views/tenant/product/Hub.vue") },
                { path: "product-master/:id", component: () => import("../views/tenant/product/MasterDetail.vue") },
                // 采购链路 · 供应商 hub 含 2 tab
                { path: "supplier-hub", component: () => import("../views/tenant/supplier/Hub.vue") },
                { path: "suppliers/:id", component: () => import("../views/tenant/supplier/Detail.vue") },
                // 销售链路 · 客户
                // 2026-10-09 客户库 hub · 客户列表 + 销售合同(集团内合同「一式两份」卖方会签)
                { path: "customers", component: () => import("../views/tenant/customer/Hub.vue") },
                { path: "customers/:id", component: () => import("../views/tenant/customer/Detail.vue") },
                { path: "sales-contracts", redirect: "/customers?tab=contracts" },
                // 采购链路 · 采购订单
                { path: "purchase-orders", component: () => import("../views/tenant/order/PurchaseOrderList.vue") },
                // 销售链路 · 销售订单
                { path: "sales-orders", component: () => import("../views/tenant/order/SalesOrderList.vue") },
                // 2026-10-12 散单 · 代销商下的零售单(代销商账号只看得到这一页)
                { path: "retail-orders", component: () => import("../views/tenant/retail/Hub.vue") },
                // 出货链路
                { path: "shipments", component: () => import("../views/tenant/shipment/Hub.vue") }, // 2026-10-13 + 待发货 / 已发货(零售包裹)
                { path: "forwarder-hub", component: () => import("../views/tenant/forwarder/Hub.vue") },
                // 财务链路
                { path: "finance-cash", component: () => import("../views/tenant/finance/CashLedger.vue") },
                { path: "finance-expense", component: () => import("../views/tenant/finance/Expenses.vue") },
                { path: "finance-refund", component: () => import("../views/tenant/finance/Refunds.vue") },
                // ROUND-8 · 库存与批次
                { path: "inventory-hub", component: () => import("../views/tenant/inventory/Hub.vue") },
                // ROUND-5-EXT · 发票与 PO + 财务报表
                { path: "finance-invoice", component: () => import("../views/tenant/finance/Invoices.vue") },
                { path: "finance-report", component: () => import("../views/tenant/finance/Reports.vue") },
                // ROUND-9 · 外部平台接入
                { path: "external-platforms", component: () => import("../views/tenant/external-platform/List.vue") },
                // ROUND-10 · 装箱单(三单据第三张)
                { path: "packing-lists", component: () => import("../views/tenant/shipment/PackingLists.vue") },
                // 2026-09-21 账号按页面授权 · 一个页面都没开时落这里
                { path: "no-access", component: () => import("../views/tenant/NoAccess.vue") },
            ],
        },
        // 平台超管端
        { path: "/platform-login", component: () => import("../views/platform/Login.vue") },
        {
            path: "/platform",
            component: () => import("../views/platform/Layout.vue"),
            children: [
                { path: "", redirect: "/platform/tenants" },
                { path: "tenants", component: () => import("../views/platform/Tenants.vue") },
                { path: "audit-log", component: () => import("../views/platform/AuditLog.vue") },
            ],
        },
    ],
});
router.beforeEach((to) => {
    const token = localStorage.getItem("token");
    const isPlatform = to.path.startsWith("/platform");
    const isLoginPage = to.path === "/login" || to.path === "/platform-login";
    if (!token && !isLoginPage) {
        return isPlatform ? "/platform-login" : "/login";
    }
    // 2026-09-21 按页面授权:不可见的页面直接敲地址也进不去(数据本来就被后端拦)
    if (token && !isPlatform && !isLoginPage) {
        const key = pageOf(to.path);
        if (key && !canSee(key)) {
            const home = firstAllowedPath();
            return home && home !== to.path ? home : "/no-access";
        }
    }
});
export default router;
//# sourceMappingURL=index.js.map